import {Injectable} from '@angular/core';
import {readProfileRaw, writeProfileJson} from './auth/auth-token.storage';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProfileSyncService {
  private readonly updated$ = new Subject<void>();

  readonly profileUpdated$ = this.updated$.asObservable();

  /** Notify listeners that localStorage `profile` was updated. */
  notifyUpdated(): void {
    this.updated$.next();
  }

  applyProfilePhoto(profilePhoto: string): void {
    this.patchStoredProfile({profilePhoto});
    this.patchSessionUser(profilePhoto);
    this.notifyUpdated();
  }

  private patchStoredProfile(patch: Record<string, unknown>): void {
    try {
      const profile = JSON.parse(readProfileRaw()) as Record<string, unknown>;
      Object.assign(profile, patch);
      writeProfileJson(JSON.stringify(profile));
    } catch {
      // ignore malformed profile cache
    }
  }

  private patchSessionUser(profilePhoto: string): void {
    try {
      const raw = sessionStorage.getItem('sessionUser');
      if (!raw) {
        return;
      }
      const user = JSON.parse(raw) as Record<string, unknown>;
      user['profilePhoto'] = profilePhoto;
      sessionStorage.setItem('sessionUser', JSON.stringify(user));
    } catch {
      // ignore malformed session cache
    }
  }
}
